export enum RTEenterTypes {
  BR = 'br',
  DIV = 'div',
  P = 'p'
}
